<template>
   <div class="page_footer2">
      <div class="max_width">
         <div class="left_logo">
            <img src="../../assets/images/2023/logo_whhite_2023.png" alt="">
         </div>
         <div class="right_tell">
            <div class="l_text">
               <p>电话:010-87635312</p>
               <p>地址:北京市东城区东大地街一号7B一层</p>
               <p>邮箱:bjia@vip.sina.com  </p>
               <p>网址:http://www.bjia.org/</p>
			   <p><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #ffffff;">京ICP备05039600号-1</a></p>
            </div>
            <div class="r_code">
               <img src="../../assets/images/2023/code_2023.jpg" alt="">
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import "@/assets/css/footer.less"
   export default {
      name: 'pageFooter',
      data() {
         return {

         };
      },
      mounted() {
        // this.getlist();
      },
      methods: {
         getlist() {
            var _this = this;
            _this.$api.linksList().then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.link = res.data;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
      }
   }
</script>
<style lang="less">

</style>
